// Simple accessible SVG donut for calories/macros
export function MacroDonut({ value, max, label, sublabel, color = "#C87D65", size = 140 }) {
  const r = size / 2 - 12;
  const c = 2 * Math.PI * r;
  const pct = max > 0 ? Math.min(value / max, 1) : 0;
  const dash = c * pct;

  return (
    <div className="flex flex-col items-center" data-testid="macro-donut">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--secondary))" strokeWidth="12" />
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="12"
            strokeLinecap="round" strokeDasharray={`${dash} ${c}`}
            style={{ transition: "stroke-dasharray 0.8s cubic-bezier(0.22,1,0.36,1)" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="font-serif text-3xl font-semibold text-foreground">{Math.round(value)}</span>
          {sublabel && <span className="text-xs text-muted-foreground">{sublabel}</span>}
        </div>
      </div>
      <span className="mt-2 text-sm font-medium text-foreground/80">{label}</span>
    </div>
  );
}

export function MacroBar({ label, value, unit, pct, color }) {
  return (
    <div data-testid={`macro-bar-${label}`}>
      <div className="flex justify-between text-sm mb-1.5">
        <span className="font-medium text-foreground/80">{label}</span>
        <span className="text-muted-foreground">{value}{unit} · {pct}%</span>
      </div>
      <div className="h-2.5 rounded-full bg-secondary overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${Math.min(100, pct)}%`, background: color, transition: "width 0.8s cubic-bezier(0.22,1,0.36,1)" }} />
      </div>
    </div>
  );
}
